const home = {
  hero_badge: "Empresa Premier de Vidrio en Las Vegas",
  hero_headline1: "Puertas de Ducha,",
  hero_headline2: "Barandales de Vidrio",
  hero_headline3: "y Espejos en Las Vegas",
  hero_sub: "Instalaciones de vidrio de precisión para hogares y negocios en todo el Valle de Las Vegas. Sin marco, moderno y duradero.",
  hero_stat1_num: "15+",
  hero_stat1_label: "Años de Experiencia",
  hero_stat2_num: "2,000+",
  hero_stat2_label: "Proyectos Completados",
  hero_stat3_num: "100%",
  hero_stat3_label: "Tasa de Satisfacción",
  services_badge: "Lo Que Hacemos",
  services_heading: "Nuestros Servicios de Vidrio",
  services_sub: "Desde puertas de ducha sin marco hasta espejos personalizados y barandales de vidrio — manejamos cada instalación con precisión y cuidado.",
  why_badge: "Por Qué Quinolux",
  why_heading1: "Artesanía de Precisión,",
  why_heading2: "Siempre",
  why_sub: "No somos solo instaladores de vidrio — somos artesanos que se enorgullecen de cada corte, cada sello y cada instalación terminada.",
  gallery_badge: "Nuestro Trabajo",
  gallery_heading: "Instalaciones Recientes",
  areas_badge: "Dónde Trabajamos",
  areas_heading1: "Sirviendo el Gran",
  areas_heading2: "Valle de Las Vegas",
  areas_sub: "Brindamos servicios premium de vidrio y espejos en todas las ciudades principales del área metropolitana de Las Vegas.",
  reviews_badge: "Calificado 5.0 en Google",
  reviews_heading: "Lo Que Dicen Nuestros Clientes",
  cta_badge: "Estimado Gratis",
  cta_heading1: "Transforma Tu",
  cta_heading2: "Espacio Hoy",
  cta_sub: "Obtenga un estimado gratuito sin compromiso para su proyecto de vidrio. Venimos a usted, medimos todo y proporcionamos una cotización detallada en 24 horas.",
  cta_reply: "Respondemos en 2 horas",
  cta_immediate: "Llame para asistencia inmediata",
  cta_form_heading: "Obtenga Su Estimado Gratis",
  cta_form_sub: "Sin compromiso. Respuesta rápida. Expertos locales.",
};

export default home;
